import { SET_PAGE } from './types';

export default function setActivePageIndex(index) {
  return ({
    type: SET_PAGE,
    payload: index,
  });
}
